import styled from "styled-components";

export const PageContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
`;

export const Form = styled.form.attrs({ noValidate: true })`
  display: flex;
  flex-direction: column;
  gap: 12px;
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  z-index: 2;
  width: 400px;
  padding: 32px;
  margin: auto;

  @media screen and (max-width: 768px) {
    width: 90vw;
    padding: 24px;
  }
`;

/* Este formulário é exibido sobre a foto fixa da floresta (LoginBg), que é
   sempre escura. Por isso os textos livres permanecem claros de forma
   intencional para manter contraste em ambos os temas. */
export const Label = styled.label`
  color: rgba(219, 251, 142, 0.9);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
  display: block;
  position: relative;
  z-index: 2;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-sizing: border-box;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }
`;

export const Img = styled.img`
  width: 280px;
  margin-bottom: 40px;
`;

export const ErrorText = styled.p`
  color: var(--danger);
  font-style: italic;
  font-size: 13px;
  margin: 0;
  text-align: center;
`;

/* Texto de apoio sobre a foto escura — mantido claro intencionalmente. */
export const HintText = styled.p`
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
  margin: -4px 0 4px 0;
  line-height: 1.4;
`;

export const RuleList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

/* Regras de senha sobre a foto escura — cores claras intencionais. */
export const RuleItem = styled.li`
  font-size: 12px;
  color: ${({ $valid }) => ($valid ? 'rgba(0, 176, 86, 0.9)' : 'rgba(255, 255, 255, 0.45)')};
  transition: color 0.2s ease;

  &::before {
    content: '${({ $valid }) => ($valid ? '✓' : '○')}';
    margin-right: 6px;
    font-weight: 700;
  }
`;

export const StyledButtonConfirmar = styled.button`
  background-color: var(--accent);
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: var(--text-on-accent);
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  flex: 1;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--accent);
    color: var(--text-on-accent);
  }

  &:active { transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
`;

export const StyledButtonVoltar = styled.button`
  background-color: var(--info);
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: var(--text-on-accent);
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  flex: 1;
  min-height: 44px;
  z-index: 2;

  &:hover {
    transform: translateY(-3px);
    border-color: var(--accent);
    color: var(--text-on-accent);
  }

  &:active { transform: translateY(-1px); }
  &:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
`;
